<script setup lang="ts">
/**
 * 年龄段徽章。
 */

import type { AgeBand } from '@spirit/contracts';

import { cn } from '../../lib/cn';
import { AGE_BAND_LABELS } from './age-band-labels';

const props = defineProps<{ ageBand: AgeBand; className?: string }>();
</script>

<template>
  <span
    :class="
      cn(
        'inline-flex items-center rounded px-1.5 py-0.5 text-[11px] text-slate-600 ring-1 ring-slate-200',
        props.className,
      )
    "
  >
    {{ AGE_BAND_LABELS[props.ageBand] }}
  </span>
</template>
